// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"list_wrapper__N0E0M","coreList":"list_coreList__rpnS5"};